import { createAsyncThunk } from '@reduxjs/toolkit';
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from '../../utils/api';
import { setAlert } from '../alerts/actions';

export const list = createAsyncThunk(
  'news/list',
  async (
    params = {
      page: 0,
      limit: 10,
      orderBy: null,
      orderDirection: null,
      filter: null,
      search: null,
    },
  ) => {
    try {
      const page = params.page ? params.page : 0;
      const limit = params.limit ? params.limit : 10;
      const res = await api.get(`/admin/news`, { params });
      console.log(page, limit);
      return { ...res.data, page, limit };
    } catch (error) {
      console.log(error);
    }
  },
);

export const create = createAsyncThunk(
  'news/create',
  async ({ data, navigate }, { dispatch }) => {
    try {
      const res = await api.post('/admin/news', data);
      dispatch(list());
      dispatch(
        setAlert({
          message: 'New Added successfully',
          alertType: 'success',
        }),
      );
      if (navigate) navigate(`/cms/news`);
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const get = createAsyncThunk('news/get', async (id, { dispatch }) => {
  try {
    const res = await api.get(`/admin/news/${id}`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) =>
        dispatch(setAlert({ message: error.message, alertType: 'error' })),
      );
    }
  }
});

export const edit = createAsyncThunk(
  'news/edit',
  async ({ id, data, navigate }, { dispatch }) => {
    try {
      console.log(data);
      await api.put(`/admin/news/${id}`, data);
      dispatch(
        setAlert({
          message: 'New updated successfully',
          alertType: 'success',
        }),
      );
      dispatch(list());
      if (navigate) navigate(`/cms/news`);
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const order = createAsyncThunk(
  'news/order',
  async (data, { dispatch }) => {
    try {
      console.log(data);
      await api.post(`/admin/news/order`, { list: data });
      dispatch(
        setAlert({
          message: 'news order updated successfully',
          alertType: 'success',
        }),
      );
      dispatch(
        list({ page: -1, limit: -1, orderBy: 'order', orderDirection: 'ASC' }),
      );
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const remove = createAsyncThunk(
  'news/remove',
  async (id, { dispatch }) => {
    try {
      await api.delete(`/admin/news/${id}`);
      dispatch(
        setAlert({
          message: 'New removed successfully',
          alertType: 'error',
        }),
      );
      dispatch(list());
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const bulk_remove = createAsyncThunk(
  'news/bulk-remove',
  async ({ data }, { dispatch }) => {
    try {
      await api.post(`/admin/news/delete`, data);
      dispatch(
        setAlert({
          message: 'News removed successfully',
          alertType: 'error',
        }),
      );
      dispatch(list());
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);
